module.exports = __webpack_public_path__ + "img/Lkw_Banner_Startseite_unten.488c5a65.webp";